"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const typography_1 = require("../../shared/typography");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const styled_components_1 = __importDefault(require("styled-components"));
const icons_1 = require("../icons");
const faTimesCircle_1 = require("@fortawesome/pro-solid-svg-icons/faTimesCircle");
const optionToJSX = ({ value, labelTranslation }) => ((0, jsx_runtime_1.jsx)("option", { value: value, children: labelTranslation }, value));
const Select = (0, react_1.forwardRef)(({ multiple, disabled, options, children, error, onReset = null, ...props }, ref) => {
    return ((0, jsx_runtime_1.jsxs)(SelectWrapper, { "data-disabled": disabled, error: error, children: [(0, jsx_runtime_1.jsxs)(typography_1.Select, { ref: ref, defaultValue: props.defaultValue, value: props.value, name: props.name, required: props.required, onChange: props.onChange, disabled: disabled, "data-selected": !!props.value, children: [options && options.map(optionToJSX), children] }, void 0), !multiple && (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ["fas", "caret-down"] }, void 0), error && (0, jsx_runtime_1.jsx)("p", { "data-cy": props["error-data-cy"], children: error }, void 0), onReset && props.value && ((0, jsx_runtime_1.jsx)(RemoveIcon, { children: (0, jsx_runtime_1.jsx)(icons_1.Icon, { shape: "circle", icon: faTimesCircle_1.faTimesCircle, size: "lg", color: "grey", onClick: onReset }, void 0) }, void 0))] }, void 0));
});
exports.Select = Select;
const RemoveIcon = styled_components_1.default.div `
  align-items: center;
  background-color: ${({ theme }) => theme.colors.whiteBase};
  cursor: pointer;
  display: flex;
  justify-content: center;
  position: absolute;
  top: 6px;
  right: 8px;

  & svg {
    position: static !important;
  }
`;
const SelectWrapper = styled_components_1.default.div `
  position: relative;

  &[data-disabled] svg {
    color: ${({ theme }) => theme.colors.greyLighten70};
  }
  svg {
    position: absolute;
    right: 1rem;
    top: calc(0.5rem + 1px);
    color: ${({ theme }) => theme.colors.greyLighten40};
    pointer-events: none;

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      /* IE10 & IE11 (no css appearance support) */
      display: none;
    }
  }

  p {
    color: ${({ theme }) => theme.colors.pinkBase};
    margin-bottom: ${({ theme }) => theme.spacings.xs};
  }

  & > select {
    ${({ error, theme }) => {
    return error ? `margin-bottom: ${theme.spacings.xs} !important;` : "";
}}
`;
//# sourceMappingURL=select.js.map